import { useField, useFormInstance } from '@adv-frontend/form-kit';
import { changeVariantPriceTooltipForm } from '..';

export const useIsMinimalPriceGreaterThanPrice = (formId: string) => {
    const formInstance = useFormInstance({ form: changeVariantPriceTooltipForm, id: formId });
    const minimalPriceField = useField(formInstance.fields.minimalPrice);
    const priceField = useField(formInstance.fields.price);

    return minimalPriceField.value && priceField.value && Number(minimalPriceField.value) > Number(priceField.value);
};
